import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminPage from './pages/AdminPages/AdminPage';
import AllQuotesPage from './pages/AdminPages/AllQuotesPage';
import DashboardPage from './pages/AdminPages/DashboardPage';
import MarkedAsReadQuotesPage from './pages/AdminPages/MarkedAsReadQuotesPage';
import MarkedAsUnreadQuotesPage from './pages/AdminPages/MarkedAsUnreadQuotesPage';
import FulfillmentPage from './pages/FufilmentPage';
import HomePage from './pages/HomePage';
import MarketingPage from './pages/MarketingPage';

const RoutesComponent = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/admin/dashboard/quotes/all/page/:page"
            element={<AllQuotesPage />}
          />
          <Route
            path="/admin/dashboard/quotes/marked-as-unread/page/:page"
            element={<MarkedAsUnreadQuotesPage />}
          />
          <Route
            path="/admin/dashboard/quotes/marked-as-read/page/:page"
            element={<MarkedAsReadQuotesPage />}
          />
          <Route path="/admin/dashboard" element={<DashboardPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/fulfillment" element={<FulfillmentPage />} />
          <Route path="/marketing" element={<MarketingPage />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Router>
    </>
  );
};

export default RoutesComponent;
